import React from "react";
import classes from "./index.module.scss";
import SFTypography from "../../../typography";

const SFLoadingRenderer = (props) => {
  return (
    <div
      className={classes.loader}
    >
      {/* we could add a loading gif here */}
      <SFTypography variant="body1"> {props.loadingMessage}</SFTypography>
    </div>
  );
};

export default SFLoadingRenderer;
